import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Award, Printer, ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { academyAPI } from '@/lib/api';
import { getErrorMessage } from '@/lib/utils';

export default function CertificatePage() {
  const { certId } = useParams();
  const navigate = useNavigate();
  const [cert, setCert] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await academyAPI.getCertificate(certId); setCert(r.data); }
      catch (e) { toast.error(getErrorMessage(e, 'Could not load certificate')); }
      finally { setLoading(false); }
    })();
  }, [certId]);

  if (loading) return <div className="flex items-center justify-center min-h-[50vh]"><Loader2 className="animate-spin text-slate-400" /></div>;
  if (!cert) return <div className="page-content">Certificate not found.</div>;

  return (
    <div className="page-content" data-testid="certificate-page">
      <div className="flex items-center justify-between mb-4 print:hidden">
        <button onClick={() => navigate('/academy')} className="text-sm text-slate-500 hover:text-slate-800 flex items-center gap-1"><ArrowLeft size={15} /> Back</button>
        <Button onClick={() => window.print()} data-testid="certificate-print"><Printer size={15} className="mr-1" /> Print / Save PDF</Button>
      </div>
      <div className="mx-auto max-w-3xl bg-white border-[6px] border-double border-amber-400 rounded-xl p-12 text-center shadow-sm" data-testid="certificate-card">
        <div className="w-16 h-16 rounded-full bg-amber-400 text-white flex items-center justify-center mx-auto mb-4"><Award size={32} /></div>
        <div className="text-xs uppercase tracking-[0.3em] text-slate-400 mb-2">Certificate of Completion</div>
        <div className="text-sm text-slate-500 mb-6">This certifies that</div>
        <div className="text-3xl font-serif font-bold text-slate-900 mb-6" data-testid="certificate-name">{cert.recipient_name}</div>
        <div className="text-sm text-slate-500 mb-1">has successfully completed</div>
        <div className="text-xl font-semibold text-slate-800 mb-6" data-testid="certificate-course">{cert.course_title}</div>
        <div className="flex items-center justify-center gap-10 text-sm text-slate-600 mt-8 border-t pt-6">
          <div><div className="font-semibold">{cert.issued_at ? new Date(cert.issued_at).toLocaleDateString() : '—'}</div><div className="text-[11px] text-slate-400">Date</div></div>
          <div><div className="font-semibold">{cert.score}%</div><div className="text-[11px] text-slate-400">Score</div></div>
          <div><div className="font-semibold">KR Agency Hub</div><div className="text-[11px] text-slate-400">Issued by</div></div>
        </div>
        <div className="text-[10px] text-slate-300 mt-6">ID: {cert.certificate_id}</div>
      </div>
    </div>
  );
}
